// extracted by mini-css-extract-plugin
module.exports = {"cards":"favoritesList_cards__1hC7S","card":"favoritesList_card__32j6R"};
    if(module.hot) {
      // 1790670303838
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  